import { createAction, props } from '@ngrx/store';

export const CheckTaxExemptions = createAction('[Customer] Check Tax Exemptions');
export const CheckTaxExemptionsSuccess = createAction(
  '[Customer] Check Tax Exemptions Success',
  props<{ result: { success: boolean; valid: boolean; status: number } }>()
);
export const CheckTaxExemptionsFail = createAction('[Customer] Check Tax Exemptions Fail', props<{ errors: any }>());

export const ResetTaxExemptionsCheck = createAction('[Customer] Reset Tax Exemptions Check');
